export default [
  {
    "编号": "ET1487",
    "姓名": "李泽阳",
    "薪资": "12500.0",
    "所在城市": "济南",
    "企业名称": "智慧矿山安全应急平台"
  },
  {
    "编号": "ET1488",
    "姓名": "丁晓蕾",
    "薪资": "14000.0",
    "所在城市": "济南",
    "企业名称": "山东省交规院项目"
  },
  {
    "编号": "ET1489",
    "姓名": "周雯彬",
    "薪资": "16000.0",
    "所在城市": "北京",
    "企业名称": "联合监督大数据平台"
  },
  {
    "编号": "ET1490",
    "姓名": "焦世超",
    "薪资": "13000.0",
    "所在城市": "德州",
    "企业名称": "信息采集平台"
  },
  {
    "编号": "ET1491",
    "姓名": "李泽睿",
    "薪资": "13000.0",
    "所在城市": "济南",
    "企业名称": "华天云PLM组"
  },
  {
    "编号": "ET1493",
    "姓名": "孙伟皓",
    "薪资": "13000.0",
    "所在城市": "东营",
    "企业名称": "胜利油田干部综合考评系统"
  },
  {
    "编号": "ET1494",
    "姓名": "姚善坤",
    "薪资": "13000.0",
    "所在城市": "东营",
    "企业名称": "胜利油田干部综合考评系统"
  },
  {
    "编号": "ET1495",
    "姓名": "薛钟欣",
    "薪资": "13000.0",
    "所在城市": "济南",
    "企业名称": "济南联通项目"
  },
  {
    "编号": "ET1496",
    "姓名": "杜晴堃",
    "薪资": "13000.0",
    "所在城市": "东营",
    "企业名称": "码头停泊管理平台"
  },
  {
    "编号": "ET1497",
    "姓名": "李宁",
    "薪资": "13500.0",
    "所在城市": "青岛",
    "企业名称": "海尔地产销售项目"
  },
  {
    "编号": "ET1500",
    "姓名": "盛远志",
    "薪资": "13000.0",
    "所在城市": "东营",
    "企业名称": "物探研究院"
  },
  {
    "编号": "ET1501",
    "姓名": "孙晓杰",
    "薪资": "13000.0",
    "所在城市": "青岛",
    "企业名称": "青特集团管理项目"
  },
  {
    "编号": "ET1504",
    "姓名": "任志杰",
    "薪资": "14500.0",
    "所在城市": "济南",
    "企业名称": "山东省交规院项目"
  },
  {
    "编号": "ET1505",
    "姓名": "梁义冬",
    "薪资": "13000.0",
    "所在城市": "济南",
    "企业名称": "石化智云油田服务"
  },
  {
    "编号": "ET1506",
    "姓名": "陈益",
    "薪资": "14000.0",
    "所在城市": "青岛",
    "企业名称": "青岛国家电网"
  },
  {
    "编号": "ET1507",
    "姓名": "高新科",
    "薪资": "13000.0",
    "所在城市": "德州",
    "企业名称": "信息采集平台"
  },
  {
    "编号": "ET1509",
    "姓名": "梁振阳",
    "薪资": "13000.0",
    "所在城市": "东营",
    "企业名称": "物探研究院"
  },
  {
    "编号": "ET1510",
    "姓名": "季铭冉",
    "薪资": "13000.0",
    "所在城市": "东营",
    "企业名称": "物探研究院"
  },
  {
    "编号": "ET1512",
    "姓名": "郭锡仓",
    "薪资": "13000.0",
    "所在城市": "东营",
    "企业名称": "物探研究院"
  },
  {
    "编号": "ET1513",
    "姓名": "孙浩",
    "薪资": "13000.0",
    "所在城市": "东营",
    "企业名称": "物探研究院"
  },
  {
    "编号": "ET1514",
    "姓名": "李胜",
    "薪资": "13000.0",
    "所在城市": "东营",
    "企业名称": "石化研究院"
  },
  {
    "编号": "ET1516",
    "姓名": "赵聪",
    "薪资": "13000.0",
    "所在城市": "济南",
    "企业名称": "华天云PLM组"
  },
  {
    "编号": "ET1517",
    "姓名": "王志强",
    "薪资": "16000.0",
    "所在城市": "北京",
    "企业名称": "联合监督大数据平台"
  },
  {
    "编号": "ET1518",
    "姓名": "陈浩男",
    "薪资": "13000.0",
    "所在城市": "东营",
    "企业名称": "物探研究院"
  },
  {
    "编号": "ET1519",
    "姓名": "冯翔",
    "薪资": "13000.0",
    "所在城市": "东营",
    "企业名称": "物探研究院"
  },
  {
    "编号": "ET1520",
    "姓名": "王猛",
    "薪资": "11500.0",
    "所在城市": "济南",
    "企业名称": "物联网卡运营支持平台"
  },
  {
    "编号": "ET1521",
    "姓名": "朱家霖",
    "薪资": "13000.0",
    "所在城市": "东营",
    "企业名称": "大庆油田部署平台"
  },
  {
    "编号": "ET1523",
    "姓名": "马兴杭",
    "薪资": "13000.0",
    "所在城市": "东营",
    "企业名称": "西南燃气管理"
  },
  {
    "编号": "ET1524",
    "姓名": "王皓炜",
    "薪资": "13000.0",
    "所在城市": "东营",
    "企业名称": "西南燃气管理"
  },
  {
    "编号": "ET1525",
    "姓名": "孙广淞",
    "薪资": "13000.0",
    "所在城市": "东营",
    "企业名称": "西南燃气管理"
  },
  {
    "编号": "ET1526",
    "姓名": "康金",
    "薪资": "13000.0",
    "所在城市": "德州",
    "企业名称": "信息采集平台"
  },
  {
    "编号": "ET1527",
    "姓名": "张敏",
    "薪资": "13000.0",
    "所在城市": "青岛",
    "企业名称": "青岛港国际物流项目"
  },
  {
    "编号": "ET1528",
    "姓名": "秦睿",
    "薪资": "13000.0",
    "所在城市": "青岛",
    "企业名称": "青岛港国际物流项目"
  },
  {
    "编号": "ET1529",
    "姓名": "石冰",
    "薪资": "13000.0",
    "所在城市": "青岛",
    "企业名称": "青岛港国际物流项目"
  },
  {
    "编号": "ET1530",
    "姓名": "李永佳",
    "薪资": "13000.0",
    "所在城市": "青岛",
    "企业名称": "青岛港国际物流项目"
  },
  {
    "编号": "ET1531",
    "姓名": "海旭",
    "薪资": "12500.0",
    "所在城市": "济南",
    "企业名称": "中船重工信息科技有限公司PLM集成接口开发及实施项目"
  },
  {
    "编号": "ET1533",
    "姓名": "宿方瑾",
    "薪资": "13000.0",
    "所在城市": "东营",
    "企业名称": "西南燃气管理"
  },
  {
    "编号": "ET1534",
    "姓名": "张梓祺",
    "薪资": "13000.0",
    "所在城市": "东营",
    "企业名称": "西南燃气管理"
  },
  {
    "编号": "ET1535",
    "姓名": "于晏卿",
    "薪资": "14000.0",
    "所在城市": "济南",
    "企业名称": "山东省交规院项目"
  },
  {
    "编号": "ET1536",
    "姓名": "徐鑫豪",
    "薪资": "15000.0",
    "所在城市": "杭州",
    "企业名称": "中创招商局供应链项目"
  },
  {
    "编号": "ET1537",
    "姓名": "韩本学",
    "薪资": "12500.0",
    "所在城市": "济南",
    "企业名称": "华天云PLM组"
  },
  {
    "编号": "ET1539",
    "姓名": "王子轩",
    "薪资": "13000.0",
    "所在城市": "东营",
    "企业名称": "大庆油田部署平台"
  },
  {
    "编号": "ET1540",
    "姓名": "王胜琪",
    "薪资": "15000.0",
    "所在城市": "北京",
    "企业名称": "中国铁道科学研究院项目"
  },
  {
    "编号": "ET1541",
    "姓名": "王梓",
    "薪资": "13500.0",
    "所在城市": "青岛",
    "企业名称": "海尔地产销售项目"
  },
  {
    "编号": "ET1542",
    "姓名": "刘治豪",
    "薪资": "13000.0",
    "所在城市": "东营",
    "企业名称": "西南燃气管理"
  },
  {
    "编号": "ET1543",
    "姓名": "孟植",
    "薪资": "13500.0",
    "所在城市": "青岛",
    "企业名称": "青岛港国际物流项目"
  },
  {
    "编号": "ET1544",
    "姓名": "张胜杰",
    "薪资": "13500.0",
    "所在城市": "青岛",
    "企业名称": "海尔地产销售项目"
  },
  {
    "编号": "ET1545",
    "姓名": "刘伊尚",
    "薪资": "13000.0",
    "所在城市": "东营",
    "企业名称": "智能油气管理"
  },
  {
    "编号": "ET1546",
    "姓名": "李永康",
    "薪资": "13000.0",
    "所在城市": "济南",
    "企业名称": "应急管理厅项目"
  },
  {
    "编号": "ET1547",
    "姓名": "张双梅",
    "薪资": "11500.0",
    "所在城市": "济南",
    "企业名称": "国家电网项目"
  },
  {
    "编号": "ET1549",
    "姓名": "程昶玮",
    "薪资": "11500.0",
    "所在城市": "济南",
    "企业名称": "国家电网项目"
  },
  {
    "编号": "ET1550",
    "姓名": "谢方童",
    "薪资": "11500.0",
    "所在城市": "济南",
    "企业名称": "国家电网项目"
  },
  {
    "编号": "ET1551",
    "姓名": "孟德业",
    "薪资": "15000.0",
    "所在城市": "深圳",
    "企业名称": "中创招商局供应链项目"
  },
  {
    "编号": "ET1552",
    "姓名": "郭树明",
    "薪资": "13000.0",
    "所在城市": "济南",
    "企业名称": "农业银行"
  },
  {
    "编号": "ET1553",
    "姓名": "石绍坤",
    "薪资": "15000.0",
    "所在城市": "北京",
    "企业名称": "中国铁道科学研究院项目"
  },
  { "编号": "ET002", "姓名": "王磊", "薪资": "14000", "所在城市": "杭州", "企业名称": "杭州华数传媒" },
  { "编号": "ET003", "姓名": "王丹丹", "薪资": "15000", "所在城市": "上海", "企业名称": "志鸿六维" },
  { "编号": "ET004", "姓名": "曹冉冉", "薪资": "17000", "所在城市": "上海", "企业名称": "科匠中国" },
  { "编号": "ET007", "姓名": "张占聪", "薪资": "17500", "所在城市": "南京", "企业名称": "南京运策物流" },
  { "编号": "ET008", "姓名": "尹勇", "薪资": "19000", "所在城市": "北京", "企业名称": "志鸿六维" },
  { "编号": "ET009", "姓名": "许壮壮", "薪资": "18000", "所在城市": "北京", "企业名称": "紫光金之盾" },
  { "编号": "ET010", "姓名": "孔祥龙", "薪资": "16000", "所在城市": "北京", "企业名称": "东信北邮" },
  { "编号": "ET011", "姓名": "支唤然", "薪资": "22000", "所在城市": "北京", "企业名称": "捷科瑞" },
  { "编号": "ET013", "姓名": "陈伟杰", "薪资": "22000", "所在城市": "上海", "企业名称": "开隆集团" },
  { "编号": "ET014", "姓名": "刘小飞", "薪资": "12000", "所在城市": "上海", "企业名称": "好芯软件" },
  { "编号": "ET015", "姓名": "张世蒙", "薪资": "22000", "所在城市": "北京", "企业名称": "捷科瑞" },
  { "编号": "ET016", "姓名": "雷鸣", "薪资": "17000", "所在城市": "北京", "企业名称": "费米东信北邮" },
  { "编号": "ET017", "姓名": "代伟", "薪资": "13000", "所在城市": "上海", "企业名称": "上海电信" },
  { "编号": "ET019", "姓名": "费义彬", "薪资": "9000", "所在城市": "苏州", "企业名称": "盖睿" },
  { "编号": "ET020", "姓名": "梁聪", "薪资": "9000", "所在城市": "杭州", "企业名称": "电信" },
  { "编号": "ET021", "姓名": "徐岩", "薪资": "12000", "所在城市": "济南", "企业名称": "胜利软件" },
  { "编号": "ET022", "姓名": "刘天晓", "薪资": "10000", "所在城市": "济南", "企业名称": "联通" },
  { "编号": "ET034", "姓名": "刘林", "薪资": "18000", "所在城市": "上海", "企业名称": "艾宜家项目组" },
  { "编号": "ET035", "姓名": "刘庆伟", "薪资": "13000", "所在城市": "上海", "企业名称": "上海欧冶" },
  { "编号": "ET036", "姓名": "樊计玉", "薪资": "12000", "所在城市": "上海", "企业名称": "绿地广财" },
  { "编号": "ET038", "姓名": "冯昊", "薪资": "10000", "所在城市": "天津", "企业名称": "天士力集团" },
  { "编号": "ET039", "姓名": "王举世", "薪资": "21000", "所在城市": "上海", "企业名称": "艾宜嘉" },
  { "编号": "ET040", "姓名": "王瑶", "薪资": "12000", "所在城市": "东营", "企业名称": "东营方圆铜业" },
  { "编号": "ET043", "姓名": "李盛昌", "薪资": "13000", "所在城市": "青岛", "企业名称": "海信阿不思" },
  { "编号": "ET044", "姓名": "贾玉萌", "薪资": "23000", "所在城市": "上海", "企业名称": "蓝鲸组志宏刘伟" },
  { "编号": "ET046", "姓名": "穆百川", "薪资": "13000", "所在城市": "上海", "企业名称": "飞牛网" },
  { "编号": "ET047", "姓名": "马李凯", "薪资": "12000", "所在城市": "上海", "企业名称": "欧耶采购公司" },
  { "编号": "ET049", "姓名": "高晓东", "薪资": "9000", "所在城市": "苏州", "企业名称": "苏州盖瑞" },
  { "编号": "ET050", "姓名": "王良", "薪资": "10000", "所在城市": "济南", "企业名称": "中创" },
  { "编号": "ET052", "姓名": "王克强", "薪资": "10000", "所在城市": "南京", "企业名称": "运策物流" },
  { "编号": "ET053", "姓名": "王朝政", "薪资": "11000", "所在城市": "北京", "企业名称": "尔创" },
  { "编号": "ET054", "姓名": "杨飞", "薪资": "9000", "所在城市": "苏州", "企业名称": "苏州盖睿" },
  { "编号": "ET055", "姓名": "周晓丽", "薪资": "12000", "所在城市": "北京", "企业名称": "北京北邮" },
  { "编号": "ET056", "姓名": "安帅", "薪资": "12000", "所在城市": "北京", "企业名称": "东信北邮" },
  { "编号": "ET058", "姓名": "李峰", "薪资": "11000", "所在城市": "北京", "企业名称": "北京指点无限公司" },
  { "编号": "ET059", "姓名": "杨阳", "薪资": "13000", "所在城市": "青岛", "企业名称": "海尔消费金融" },
  { "编号": "ET060", "姓名": "袁宏伟", "薪资": "10000", "所在城市": "北京", "企业名称": "东信北邮" },
  { "编号": "ET061", "姓名": "曹恒福", "薪资": "9500", "所在城市": "杭州", "企业名称": "咪咕阅读" },
  { "编号": "ET062", "姓名": "张程", "薪资": "10300", "所在城市": "北京", "企业名称": "东信北邮" },
  { "编号": "ET063", "姓名": "邓晓", "薪资": "16000", "所在城市": "北京", "企业名称": "联想" },
  { "编号": "ET064", "姓名": "那光升", "薪资": "16000", "所在城市": "北京", "企业名称": "中石油" },
  { "编号": "ET065", "姓名": "李闯", "薪资": "14000", "所在城市": "南京", "企业名称": "江苏北斗" },
  { "编号": "ET066", "姓名": "周婷", "薪资": "14500", "所在城市": "天津", "企业名称": "中海油" },
  { "编号": "ET067", "姓名": "李传昭", "薪资": "11000", "所在城市": "济南", "企业名称": "方盛有成" },
  { "编号": "ET068", "姓名": "田振", "薪资": "9000", "所在城市": "青岛", "企业名称": "罗克" },
  { "编号": "ET069", "姓名": "钱跃", "薪资": "9810", "所在城市": "天津", "企业名称": "中国海洋石油工程设计研发中心" },
  { "编号": "ET070", "姓名": "张国营", "薪资": "10000", "所在城市": "青岛", "企业名称": "罗克环球" },
  { "编号": "ET071", "姓名": "严磊", "薪资": "12000", "所在城市": "东营", "企业名称": "胜软" },
  { "编号": "ET072", "姓名": "于瀚韬", "薪资": "18000", "所在城市": "上海", "企业名称": "邦信" },
  { "编号": "ET073", "姓名": "孔祥宗", "薪资": "15000", "所在城市": "上海", "企业名称": "蓝鲸" },
  { "编号": "ET074", "姓名": "贾文", "薪资": "10280", "所在城市": "北京", "企业名称": "东信北邮" },
  { "编号": "ET075", "姓名": "许宁", "薪资": "12000", "所在城市": "青岛", "企业名称": "公交监管" },
  { "编号": "ET076", "姓名": "卜布", "薪资": "11000", "所在城市": "北京", "企业名称": "指点控股" },
  { "编号": "ET077", "姓名": "曹瑞芳", "薪资": "10800", "所在城市": "济南", "企业名称": "中国联通" },
  { "编号": "ET078", "姓名": "陈新", "薪资": "13000", "所在城市": "上海", "企业名称": "中国海事局" },
  { "编号": "ET079", "姓名": "何灿", "薪资": "10300", "所在城市": "上海", "企业名称": "上海电信" },
  { "编号": "ET080", "姓名": "施文星", "薪资": "14700", "所在城市": "上海", "企业名称": "天地华宇" },
  { "编号": "ET081", "姓名": "李涛", "薪资": "13000", "所在城市": "西安", "企业名称": "联通加密通话" },
  { "编号": "ET083", "姓名": "李玉立", "薪资": "18000", "所在城市": "上海", "企业名称": "蓝鲸世纪科技有限公司" },
  { "编号": "ET084", "姓名": "石超", "薪资": "15000", "所在城市": "上海", "企业名称": "上海华勤" },
  { "编号": "ET085", "姓名": "王柄林", "薪资": "7000", "所在城市": "济南", "企业名称": "济南东芝林软件公司" },
  { "编号": "ET086", "姓名": "郭庆轩", "薪资": "8700", "所在城市": "济南", "企业名称": "方天鲁软组" },
  { "编号": "ET088", "姓名": "田林", "薪资": "16000", "所在城市": "北京", "企业名称": "捷科瑞" },
  { "编号": "ET089", "姓名": "周海川", "薪资": "11000", "所在城市": "廊坊", "企业名称": "新奥" },
  { "编号": "ET090", "姓名": "陈敏", "薪资": "18000", "所在城市": "上海", "企业名称": "彩票项目" },
  { "编号": "ET091", "姓名": "冯松", "薪资": "10000", "所在城市": "上海", "企业名称": "电信理想" },
  { "编号": "ET092", "姓名": "赵齐", "薪资": "11000", "所在城市": "杭州", "企业名称": "华数" },
  { "编号": "ET093", "姓名": "李鹏飞", "薪资": "9000", "所在城市": "济南", "企业名称": "易贸创想" },
  { "编号": "ET094", "姓名": "江玉泉", "薪资": "9000", "所在城市": "南京", "企业名称": "中国移动游戏基地" },
  { "编号": "ET096", "姓名": "王鹏", "薪资": "10500", "所在城市": "北京", "企业名称": "东信北邮" },
  { "编号": "ET095", "姓名": "王超洋", "薪资": "15000", "所在城市": "西安", "企业名称": "明朝万达" },
  { "编号": "ET097", "姓名": "许丹丹", "薪资": "17000", "所在城市": "上海", "企业名称": "绿地集团" },
  { "编号": "ET098", "姓名": "张凯", "薪资": "10500", "所在城市": "北京", "企业名称": "东信北邮" },
  { "编号": "ET099", "姓名": "张志伟", "薪资": "10500", "所在城市": "北京", "企业名称": "东信北邮" },
  { "编号": "ET100", "姓名": "张帅", "薪资": "850/天", "所在城市": "北京", "企业名称": "中石油" },
  { "编号": "ET101", "姓名": "杨志鹏", "薪资": "12000", "所在城市": "北京", "企业名称": "北京分豆教育" },
  { "编号": "ET102", "姓名": "任杨杨", "薪资": "10500", "所在城市": "上海", "企业名称": "上海感知集团" },
  { "编号": "ET104", "姓名": "门艳辉", "薪资": "12000", "所在城市": "上海", "企业名称": "上海中芯国际" },
  { "编号": "ET105", "姓名": "马勇鹏", "薪资": "12000", "所在城市": "上海", "企业名称": "上海中芯国际" },
  { "编号": "ET106", "姓名": "刁兆臣", "薪资": "9000", "所在城市": "济南", "企业名称": "联通" },
  { "编号": "ET107", "姓名": "杨丽", "薪资": "14000", "所在城市": "上海", "企业名称": "志鸿科技" },
  { "编号": "ET108", "姓名": "刘旭涛", "薪资": "12000", "所在城市": "上海", "企业名称": "中芯国际" },
  { "编号": "ET111", "姓名": "张梦晓", "薪资": "16000", "所在城市": "上海", "企业名称": "开隆集团" },
  { "编号": "ET112", "姓名": "王华晨", "薪资": "9000", "所在城市": "济南", "企业名称": "济南东之林" },
  { "编号": "ET113", "姓名": "杨春华", "薪资": "14000", "所在城市": "上海", "企业名称": "志鸿六维" },
  { "编号": "ET114", "姓名": "刘志", "薪资": "9000", "所在城市": "济南", "企业名称": "联通" },
  { "编号": "ET116", "姓名": "张国栋", "薪资": "13000", "所在城市": "济南", "企业名称": "方胜有成" },
  { "编号": "ET119", "姓名": "付景涛", "薪资": "13000", "所在城市": "济南", "企业名称": "方胜有成" },
  { "编号": "ET120", "姓名": "颜杰", "薪资": "9000", "所在城市": "济南", "企业名称": "联通" },
  { "编号": "ET121", "姓名": "边兴华", "薪资": "12000", "所在城市": "北京", "企业名称": "东信北邮" },
  { "编号": "ET122", "姓名": "苗东昌", "薪资": "13000", "所在城市": "上海", "企业名称": "赵涌在线" },
  { "编号": "ET123", "姓名": "李翔康", "薪资": "9000", "所在城市": "济南", "企业名称": "联通" },
  { "编号": "ET124", "姓名": "杨培培", "薪资": "9000", "所在城市": "济南", "企业名称": "联通集成" },
  { "编号": "ET125", "姓名": "解洪雷", "薪资": "12000", "所在城市": "北京", "企业名称": "东信北邮" },
  { "编号": "ET126", "姓名": "周国楷", "薪资": "13000", "所在城市": "青岛", "企业名称": "青岛海信" },
  { "编号": "ET127", "姓名": "吕洪赞", "薪资": "12000", "所在城市": "青岛", "企业名称": "青岛海尔" },
  { "编号": "ET128", "姓名": "郝敬东", "薪资": "12000", "所在城市": "北京", "企业名称": "东信北邮" },
  { "编号": "ET129", "姓名": "石秦", "薪资": "10000", "所在城市": "杭州", "企业名称": "浙江省华数传媒" },
  { "编号": "ET130", "姓名": "迟方凯", "薪资": "10000", "所在城市": "苏州", "企业名称": "盈天地科技" },
  { "编号": "ET133", "姓名": "任彤彤", "薪资": "18000", "所在城市": "上海", "企业名称": "消防大数据" },
  { "编号": "ET135", "姓名": "曹威", "薪资": "12000", "所在城市": "北京", "企业名称": "东信北邮" },
  { "编号": "ET137", "姓名": "王梦轩", "薪资": "12000", "所在城市": "北京", "企业名称": "东信北邮" },
  { "编号": "ET138", "姓名": "刘得淼", "薪资": "12000", "所在城市": "南京", "企业名称": "江苏公用信息" },
  { "编号": "ET139", "姓名": "高良", "薪资": "11000", "所在城市": "南京", "企业名称": "江苏省公用信息" },
  { "编号": "ET140", "姓名": "高成", "薪资": "15000", "所在城市": "北京", "企业名称": "紫光金之动" },
  { "编号": "ET141", "姓名": "冯尔艺", "薪资": "14000", "所在城市": "上海", "企业名称": "上海志鸿六维" },
  { "编号": "ET142", "姓名": "刘存飞", "薪资": "14000", "所在城市": "北京", "企业名称": "捷科瑞" },
  { "编号": "ET143", "姓名": "袁海涛", "薪资": "13000", "所在城市": "青岛", "企业名称": "海信" },
  { "编号": "ET146", "姓名": "刘云龙", "薪资": "11000", "所在城市": "青岛", "企业名称": "海信平安组" },
  { "编号": "ET149", "姓名": "崔晓亮", "薪资": "10500", "所在城市": "上海", "企业名称": "上海理想信息产业" },
  { "编号": "ET150", "姓名": "张超", "薪资": "10520", "所在城市": "苏州", "企业名称": "苏州盈天地资讯科技" },
  { "编号": "ET151", "姓名": "赵才森", "薪资": "11000", "所在城市": "北京", "企业名称": "指点无线科技" },
  { "编号": "ET152", "姓名": "阮超", "薪资": "16000", "所在城市": "杭州", "企业名称": "D空间" },
  { "编号": "ET153", "姓名": "史明泽", "薪资": "17000", "所在城市": "上海", "企业名称": "科匠中国" },
  { "编号": "ET154", "姓名": "刘志", "薪资": "13000", "所在城市": "北京", "企业名称": "北京分豆教育" },
  { "编号": "ET157", "姓名": "任小龙", "薪资": "17000", "所在城市": "上海", "企业名称": "上海中芯" },
  { "编号": "ET158", "姓名": "常俊", "薪资": "18000", "所在城市": "上海", "企业名称": "德勤" },
  { "编号": "ET160", "姓名": "王叶青", "薪资": "11000", "所在城市": "上海", "企业名称": "上海亿盟科技" },
  { "编号": "ET161", "姓名": "陈静民", "薪资": "12000", "所在城市": "杭州", "企业名称": "余杭农村商业银行" },
  { "编号": "ET162", "姓名": "戎旭", "薪资": "14000", "所在城市": "杭州", "企业名称": "D空间" },
  { "编号": "ET163", "姓名": "王泽勉", "薪资": "14500", "所在城市": "天津", "企业名称": "中海油" },
  { "编号": "ET165", "姓名": "吴海鹏", "薪资": "12000", "所在城市": "上海", "企业名称": "上海隽讯科技" },
  { "编号": "ET166", "姓名": "董文毅", "薪资": "12000", "所在城市": "上海", "企业名称": "上海亿盟信息" },
  { "编号": "ET169", "姓名": "钱敏", "薪资": "11000", "所在城市": "青岛", "企业名称": "海信平安组" },
  { "编号": "ET170", "姓名": "李凤帅", "薪资": "13000", "所在城市": "青岛", "企业名称": "海信新研发中心" },
  { "编号": "ET171", "姓名": "李涛", "薪资": "9000", "所在城市": "济南", "企业名称": "联通" },
  { "编号": "ET174", "姓名": "王翔", "薪资": "10000", "所在城市": "杭州", "企业名称": "华数" },
  { "编号": "ET175", "姓名": "池启龙", "薪资": "10000", "所在城市": "苏州", "企业名称": "盖瑞" },
  { "编号": "ET176", "姓名": "李程", "薪资": "12000", "所在城市": "北京", "企业名称": "分豆教育" },
  { "编号": "ET177", "姓名": "韩梦俊", "薪资": "20000", "所在城市": "上海", "企业名称": "德勤" },
  { "编号": "ET178", "姓名": "龙胜利", "薪资": "12000", "所在城市": "南京", "企业名称": "南京欣网互联网络" },
  { "编号": "ET179", "姓名": "吴春蒙", "薪资": "8500", "所在城市": "北京", "企业名称": "北京盛源智能终端" },
  { "编号": "ET181", "姓名": "鲁祎明", "薪资": "8500", "所在城市": "北京", "企业名称": "北京盛源" },
  { "编号": "ET182", "姓名": "彭延飞", "薪资": "12000", "所在城市": "青岛", "企业名称": "海信" },
  { "编号": "ET183", "姓名": "饶崇信", "薪资": "12000", "所在城市": "青岛", "企业名称": "青岛交警支队" },
  { "编号": "ET184", "姓名": "闫绪明", "薪资": "9000", "所在城市": "济南", "企业名称": "联通" },
  { "编号": "ET185", "姓名": "张振波", "薪资": "12000", "所在城市": "青岛", "企业名称": "海信平安城市" },
  { "编号": "ET187", "姓名": "刘振兴", "薪资": "16000", "所在城市": "贵阳", "企业名称": "贵阳BBD大数据中心" },
  { "编号": "ET188", "姓名": "苏志恒", "薪资": "9000", "所在城市": "济南", "企业名称": "鲁能软件中核集团" },
  { "编号": "ET189", "姓名": "江文利", "薪资": "12000", "所在城市": "上海", "企业名称": "上海上汽集团" },
  { "编号": "ET190", "姓名": "刘长青", "薪资": "8000", "所在城市": "东营", "企业名称": "方圆铜业" },
  { "编号": "ET191", "姓名": "李建委", "薪资": "11000", "所在城市": "济南", "企业名称": "中创软件" },
  { "编号": "ET193", "姓名": "施春波", "薪资": "18000", "所在城市": "北京", "企业名称": "紫光金之动" },
  { "编号": "ET195", "姓名": "凌世轩", "薪资": "11000", "所在城市": "北京", "企业名称": "海尔日日顺乐家（友明）" },
  { "编号": "ET197", "姓名": "刘洋", "薪资": "10000", "所在城市": "廊坊", "企业名称": "新奥控股" },
  { "编号": "ET200", "姓名": "赵清源", "薪资": "12000", "所在城市": "北京", "企业名称": "国美" },
  { "编号": "ET202", "姓名": "贾晨浩", "薪资": "12000", "所在城市": "北京", "企业名称": "北京分豆教育" },
  { "编号": "ET203", "姓名": "焦玉莲", "薪资": "12000", "所在城市": "北京", "企业名称": "北京分豆教育" },
  { "编号": "ET204", "姓名": "郑宽飞", "薪资": "12000", "所在城市": "北京", "企业名称": "北京分豆教育" },
  { "编号": "ET205", "姓名": "才让旦智", "薪资": "14000", "所在城市": "北京", "企业名称": "华为" },
  { "编号": "ET206", "姓名": "苏博", "薪资": "10000", "所在城市": "天津", "企业名称": "中海油" },
  { "编号": "ET207", "姓名": "马金富", "薪资": "10000", "所在城市": "南京", "企业名称": "途牛" },
  { "编号": "ET208", "姓名": "陈跃强", "薪资": "12000", "所在城市": "上海", "企业名称": "东方CJ" },
  { "编号": "ET211", "姓名": "陈新明", "薪资": "12000", "所在城市": "上海", "企业名称": "东方CJ" },
  { "编号": "ET212", "姓名": "魏言通", "薪资": "12000", "所在城市": "上海", "企业名称": "东方CJ" },
  { "编号": "ET214", "姓名": "郑涛", "薪资": "9000", "所在城市": "济南", "企业名称": "联通" },
  { "编号": "ET216", "姓名": "刘帅", "薪资": "10000", "所在城市": "杭州", "企业名称": "华数" },
  { "编号": "ET217", "姓名": "孙曙光", "薪资": "10000", "所在城市": "杭州", "企业名称": "华数传媒有限公司" },
  { "编号": "ET220", "姓名": "周炎通", "薪资": "14000", "所在城市": "北京", "企业名称": "光大银行" },
  { "编号": "ET224", "姓名": "孔师", "薪资": "7800", "所在城市": "济南", "企业名称": "青岛方天" },
  { "编号": "ET225", "姓名": "郑河", "薪资": "10000", "所在城市": "杭州", "企业名称": "杭州电信" },
  { "编号": "ET227", "姓名": "曹瑞", "薪资": "8000", "所在城市": "济南", "企业名称": "胜软科技" },
  { "编号": "ET228", "姓名": "仇志越", "薪资": "9000", "所在城市": "济南", "企业名称": "联通" },
  { "编号": "ET229", "姓名": "栾素珍", "薪资": "9000", "所在城市": "济南", "企业名称": "联通" },
  { "编号": "ET231", "姓名": "石海红", "薪资": "11000", "所在城市": "北京", "企业名称": "尔创" },
  { "编号": "ET232", "姓名": "陈美双", "薪资": "11000", "所在城市": "北京", "企业名称": "尔创" },
  { "编号": "ET235", "姓名": "胡庆悦", "薪资": "9000", "所在城市": "济南", "企业名称": "济南联通" },
  { "编号": "ET237", "姓名": "崔鑫", "薪资": "10000", "所在城市": "济南", "企业名称": "中国移动设计院山东分院" },
  { "编号": "ET238", "姓名": "程赓", "薪资": "10000", "所在城市": "南京", "企业名称": "上古" },
  { "编号": "ET239", "姓名": "王军", "薪资": "13000", "所在城市": "北京", "企业名称": "指点无限科技有限公司" },
  { "编号": "ET241", "姓名": "方俊凯", "薪资": "8000", "所在城市": "济南", "企业名称": "联通" },
  { "编号": "ET242", "姓名": "刘容衫", "薪资": "9000", "所在城市": "济南", "企业名称": "联通" },
  { "编号": "ET244", "姓名": "安云贵", "薪资": "8000", "所在城市": "济南", "企业名称": "济南有鸿" },
  { "编号": "ET247", "姓名": "付秀", "薪资": "10000", "所在城市": "青岛", "企业名称": "海尔" },
  { "编号": "ET249", "姓名": "张磊", "薪资": "10000", "所在城市": "南京", "企业名称": "南京上古" },
  { "编号": "ET251", "姓名": "杨晓林", "薪资": "10000", "所在城市": "南京", "企业名称": "南京上古" },
  { "编号": "ET252", "姓名": "王忠方", "薪资": "10000", "所在城市": "南京", "企业名称": "南京上古" },
  { "编号": "ET253", "姓名": "马凤亚", "薪资": "10000", "所在城市": "南京", "企业名称": "南京上古" },
  { "编号": "ET254", "姓名": "赵东源", "薪资": "14000", "所在城市": "西安", "企业名称": "西安项目组" },
  { "编号": "ET256", "姓名": "张文龙", "薪资": "11000", "所在城市": "上海", "企业名称": "上海汽车集团" },
  { "编号": "ET257", "姓名": "高晓龙", "薪资": "10000", "所在城市": "南京", "企业名称": "江苏电力公司" },
  { "编号": "ET261", "姓名": "刘高林", "薪资": "9000", "所在城市": "贵阳", "企业名称": "启圆" },
  { "编号": "ET262", "姓名": "朱孟兴", "薪资": "9000", "所在城市": "贵州", "企业名称": "贵阳太升国际" },
  { "编号": "ET263", "姓名": "李延滨", "薪资": "10000", "所在城市": "南京", "企业名称": "江苏鸿信系统集成" },
  { "编号": "ET264", "姓名": "穆立山", "薪资": "8000", "所在城市": "济南", "企业名称": "东之林" },
  { "编号": "ET265", "姓名": "孟繁正", "薪资": "9000", "所在城市": "济南", "企业名称": "济南联通集成" },
  { "编号": "ET266", "姓名": "刘春龙", "薪资": "10500", "所在城市": "苏州", "企业名称": "苏高新软件园" },
  { "编号": "ET267", "姓名": "舒立东", "薪资": "14000", "所在城市": "杭州", "企业名称": "D空间" },
  { "编号": "ET269", "姓名": "于克磊", "薪资": "12000", "所在城市": "北京", "企业名称": "国网能源研究院" },
  { "编号": "ET270", "姓名": "彭苗苗", "薪资": "10000", "所在城市": "苏州", "企业名称": "苏州盈天地资讯科技有限公司" },
  { "编号": "ET273", "姓名": "尚绪峰", "薪资": "10000", "所在城市": "南京", "企业名称": "江苏鸿信系统集成有限公司" },
  { "编号": "ET274", "姓名": "赵嘉凯", "薪资": "12000", "所在城市": "杭州", "企业名称": "杭州余杭农村商业银行" },
  { "编号": "ET277", "姓名": "刘会君", "薪资": "9000", "所在城市": "济南", "企业名称": "泰华" },
  { "编号": "ET281", "姓名": "张颜开", "薪资": "10000", "所在城市": "北京", "企业名称": "尔创科技" },
  { "编号": "ET282", "姓名": "禹雪", "薪资": "11000", "所在城市": "北京", "企业名称": "尔创科技" },
  { "编号": "ET285", "姓名": "武明凯", "薪资": "11000", "所在城市": "南京", "企业名称": "南京北斗卫星应用研究院" },
  { "编号": "ET286", "姓名": "温建鑫", "薪资": "9300", "所在城市": "南京", "企业名称": "北斗卫星" },
  { "编号": "ET287", "姓名": "李勃阳", "薪资": "12000", "所在城市": "济南", "企业名称": "胜利软件" },
  { "编号": "ET289", "姓名": "张娇", "薪资": "9000", "所在城市": "济南", "企业名称": "联通" },
  { "编号": "ET290", "姓名": "王波波", "薪资": "12000", "所在城市": "北京", "企业名称": "国家电网" },
  { "编号": "ET291", "姓名": "卢健", "薪资": "12000", "所在城市": "北京", "企业名称": "光大银行" },
  { "编号": "ET292", "姓名": "刘朋召", "薪资": "13000", "所在城市": "北京", "企业名称": "中国人民银行清算总中心" },
  { "编号": "ET294", "姓名": "禚先林", "薪资": "11000", "所在城市": "南京", "企业名称": "南京民卡" },
  { "编号": "ET296", "姓名": "薛俊辉", "薪资": "10000", "所在城市": "南京", "企业名称": "鸿信公司" },
  { "编号": "ET298", "姓名": "王邵军", "薪资": "11000", "所在城市": "重庆", "企业名称": "常州洪荒浩宇" },
  { "编号": "ET299", "姓名": "邹振钰", "薪资": "10000", "所在城市": "南京", "企业名称": "途牛" },
  { "编号": "ET300", "姓名": "周童", "薪资": "10000", "所在城市": "南京", "企业名称": "徐庄软件园江苏银行" },
  { "编号": "ET301", "姓名": "孟宪令", "薪资": "10000", "所在城市": "南京", "企业名称": "创发科技" },
  { "编号": "ET302", "姓名": "王鲲鹏", "薪资": "10000", "所在城市": "南京", "企业名称": "徐庄软件园江苏银行" },
  { "编号": "ET303", "姓名": "马玉理", "薪资": "10000", "所在城市": "南京", "企业名称": "徐庄软件园江苏银行" },
  { "编号": "ET304", "姓名": "张亮亮", "薪资": "10000", "所在城市": "南京", "企业名称": "上海诺祺科技有限公司" },
  { "编号": "ET305", "姓名": "高长瑞", "薪资": "10000", "所在城市": "杭州", "企业名称": "华数" },
  { "编号": "ET306", "姓名": "臧增辉", "薪资": "11000", "所在城市": "天津", "企业名称": "天士力" },
  { "编号": "ET309", "姓名": "王路通", "薪资": "11000", "所在城市": "杭州", "企业名称": "浙江电子电力技术公司" },
  { "编号": "ET310", "姓名": "徐才贵", "薪资": "10000", "所在城市": "南京", "企业名称": "南京途牛" }
]




// WEBPACK FOOTER //
// ./src/common/data.js